import { Link, styled, Typography } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

export const ProfileHeaderContainer = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  position: "relative",

  "& > *": {
    marginBottom: theme.spacing(2),
    color: theme.palette.common.white,
  },
}));

export const ProfileTitle = styled(Typography)({
  fontWeight: 700,
});

export const BreadcrumbLink = styled(Link)(({ theme, secondary }) => {
  const color = secondary
    ? theme.palette.grey[500]
    : theme.palette.common.white;

  return {
    color,
    "&:hover": {
      color,
    },

    "&:focus": {
      color,
    },
  };
});

export const BreadcrumbElement = styled("span")(({ theme, secondary }) => ({
  marginRight: theme.spacing(0.75),
  color: secondary ? theme.palette.grey[500] : theme.palette.common.white,
}));

export const SelectSiteContainer = styled("div")(({ theme }) => ({
  display: "flex",
  cursor: "pointer",
  alignItems: "flex-end",
  "&:hover": {
    textDecoration: "underline",
    textDecorationColor: theme.palette.grey[500],
  },
}));

export const BreadcrumbDropdownArrow = styled(ExpandMore)(
  ({ theme, secondary }) => ({
    fill: secondary ? theme.palette.grey[500] : theme.palette.common.white,
  })
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/ProfileHeader/ProfileHeader.styles.js